"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var HttpDocumentSearchService = /** @class */ (function () {
    function HttpDocumentSearchService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.serviceUrlKey = 'ejustice-document-service-url';
        this.serviceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.serviceUrlKey));
    }
    HttpDocumentSearchService.prototype.searchDocuments = function (searchText, searchFiltersConfig, pagingConfig, withEntityData, withDocumentData, sortConfig, excludedCategories) {
        var _this = this;
        if (withEntityData === void 0) { withEntityData = false; }
        if (withDocumentData === void 0) { withDocumentData = false; }
        return this.serviceUrl$.pipe(operators_1.mergeMap(function (serviceUrl) {
            var url = serviceUrl + "/document-operations/search";
            var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' })
                .append('x-version', '2');
            var body = {
                excludedCategories: excludedCategories ? excludedCategories : [],
                searchFilters: searchFiltersConfig,
                queryTerm: searchText,
                withEntityData: withEntityData,
                withDocumentData: withDocumentData
            };
            sortConfig && (body['sortOptions'] = sortConfig);
            pagingConfig && (body['pagingOptions'] = pagingConfig);
            var options = { headers: headers, observe: 'response' };
            return _this.http.post(url, body, options).map(function (data) {
                return { status: data['status'], documents: data['body'] };
            });
        }));
    };
    HttpDocumentSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpDocumentSearchService);
    return HttpDocumentSearchService;
}());
exports.HttpDocumentSearchService = HttpDocumentSearchService;
//# sourceMappingURL=http-document-search-service.js.map